module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-L-47.1cf0bcef.png";